import React from "react";

/** Cloche + receipt empty state — matches POS reference mockup. */
export default function PosEmptyIllustration({ className = "" }) {
  return (
    <svg
      viewBox="0 0 120 100"
      className={className}
      aria-hidden
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="60" cy="88" rx="38" ry="6" fill="#F36F21" fillOpacity="0.08" />
      <path
        d="M30 52c0-14 13.5-24 30-24s30 10 30 24"
        stroke="#F36F21"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="#FFF3E8"
        fillOpacity="0.6"
      />
      <path d="M28 52h64v8H28z" fill="#F36F21" fillOpacity="0.15" stroke="#F36F21" strokeWidth="1.5" />
      <circle cx="60" cy="28" r="5" fill="#F36F21" fillOpacity="0.35" />
      <rect x="72" y="58" width="22" height="28" rx="3" fill="#fff" stroke="#E8D5C8" strokeWidth="1.5" />
      <line x1="76" y1="66" x2="90" y2="66" stroke="#F0E0D4" strokeWidth="2" strokeLinecap="round" />
      <line x1="76" y1="72" x2="88" y2="72" stroke="#F0E0D4" strokeWidth="2" strokeLinecap="round" />
      <line x1="76" y1="78" x2="90" y2="78" stroke="#F0E0D4" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
